export const BUZZ_BONUS_BALANCE = 'bonus-balance';

export const ALL_BONUS_TYPE = 'all';

export enum BONUS_VIEW_TYPES {
    active = 'active',
    expired = 'expired'
}

export enum BONUS_STATUSES {
    ISSUED = 1,
    ACCEPTED = 2,
    ACTIVE = 3,
    WAGERING_COMPLETED = 4,
    EXPIRED = 5,
    DECLINED = 6,
    CANCELLED = 7,
    REDEEMED = 8
}

export const ACTIVE_STATUSES = [
    BONUS_STATUSES.ISSUED,
    BONUS_STATUSES.ACCEPTED,
    BONUS_STATUSES.ACTIVE
];

export const ALLOWED_BINGO_STATUSES = ['ACTIVE', 'SPENT'];

export const STATUSES_MAP = {
    [BONUS_STATUSES.ISSUED]: { modificator: 'active', tKey: 'issued' },
    [BONUS_STATUSES.ACCEPTED]: { modificator: 'active', tKey: 'accepted' },
    [BONUS_STATUSES.ACTIVE]: { modificator: 'active', tKey: 'active' },
    [BONUS_STATUSES.WAGERING_COMPLETED]: { modificator: 'pending', tKey: 'wageringCompleted' },
    [BONUS_STATUSES.EXPIRED]: { modificator: 'pending', tKey: 'expired' },
    [BONUS_STATUSES.DECLINED]: { modificator: 'declined', tKey: 'declined' },
    [BONUS_STATUSES.CANCELLED]: { modificator: 'declined', tKey: 'cancelled' },
    [BONUS_STATUSES.REDEEMED]: { modificator: 'pending', tKey: 'redeemed' }
};

export const REQUEST_PARAMS = {
    GAMES_BONUS_HISTORY: { balanceType: 'All Games Bonus', correlationId: 'GAMES_BONUS_HISTORY' },
    BINGO_BONUS_HISTORY: { balanceType: 'Bingo Bonus', correlationId: 'BINGO_BONUS_HISTORY' }
};
